import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { SoilType } from 'src/app/soil-type/soil-type.model';
import { Environment } from 'src/environments/environment.model';

@Injectable({
  providedIn: 'root',
})
export class SoilTypeApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/arable-service/soiltype';

  getSoilTypes(): Observable<SoilType[]> {
    return this.http.get<SoilType[]>(this.baseUrl);
  }
}
